import axios from "axios"

export const fetchTicket = async (ticketData: any) => {
    const { data } = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}tickets/find`,
        ticketData
    )

    return data
}
